 import React from "react";
import PropTypes from "prop-types";

const AudioPlayer = (props) => {
  const { audioSrc } = props;

  function getFileFormat(url) {
    const dotIndex = url.lastIndexOf('.');
    if (dotIndex === -1) {
      return ''; 
    }
    return url.substring(dotIndex + 1);
  }
  const fileFormat = getFileFormat(audioSrc);
  return (
    <div style={{ margin: "10px" }}>
      <audio controls src={audioSrc} type={"audio/"+fileFormat} />
    </div>
  );
};

AudioPlayer.propTypes = {
  audioSrc: PropTypes.string,
};

export default AudioPlayer;